import {
  FileText,
  Mic,
  AudioLines,
  ClipboardCheck,
  FileDown,
  History,
  type LucideIcon,
} from "lucide-react";
import { Reveal } from "./Reveal";

const features: { icon: LucideIcon; title: string; desc: string }[] = [
  {
    icon: FileText,
    title: "AI SOAP Notes",
    desc: "A SOAP note generator that creates accurate, professional notes from natural conversations.",
  },
  {
    icon: Mic,
    title: "Voice Recording",
    desc: "Record patient visits with one click—no extra hardware required.",
  },
  {
    icon: AudioLines,
    title: "Accurate Transcription",
    desc: "Automatically distinguish between provider and patient as they speak.",
  },
  {
    icon: ClipboardCheck,
    title: "Documentation Assistant",
    desc: "Identify missing documentation before finalizing your notes.",
  },
  {
    icon: FileDown,
    title: "PDF Export & Copy",
    desc: "Export beautifully formatted notes or copy directly into your EMR.",
  },
  {
    icon: History,
    title: "Patient History",
    desc: "Quickly access previous patient visits and documentation.",
  },
];

export function Features() {
  return (
    <section id="features" className="scroll-mt-24 bg-white py-24">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal className="mx-auto max-w-2xl text-center">
          <span className="text-sm font-semibold uppercase tracking-wider text-blue-600">
            Features
          </span>
          <h2 className="mt-3 text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
            Everything you need to chart faster
          </h2>
          <p className="mt-4 text-lg text-slate-600">
            Clinical documentation software purpose-built to turn every patient conversation into
            a clean, complete clinical note.
          </p>
        </Reveal>

        <div className="mt-16 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {features.map(({ icon: Icon, title, desc }, i) => (
            <Reveal key={title} delay={(i % 3) * 0.1}>
              <div className="group h-full rounded-2xl border border-slate-200/80 bg-white p-7 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:border-blue-200 hover:shadow-xl hover:shadow-blue-900/5">
                <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-blue-50 text-blue-600 transition-all duration-300 group-hover:scale-110 group-hover:bg-blue-600 group-hover:text-white">
                  <Icon className="h-6 w-6" />
                </div>
                <h3 className="mt-5 text-lg font-semibold text-slate-900">{title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-600">{desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
